import { render, staticRenderFns } from "./DeliveryNew_Items.vue?vue&type=template&id=1c5ac0ff&"
import script from "./DeliveryNew_Items.vue?vue&type=script&lang=js&"
export * from "./DeliveryNew_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports